<mat-card>
  <mat-card-title>
    {{
      (data.gatewaySerial
        ? 'DEREGISTER_GATEWAY_MODAL.TITLE'
        : 'DEREGISTER_INSTALLATION_MODAL.TITLE'
      ) | translate
    }}
  </mat-card-title>
  <mat-card-content class="flex flex-col gap-[20px]">
    <div>
      {{
        (data.gatewaySerial
          ? 'DEREGISTER_GATEWAY_MODAL.TEXT'
          : 'DEREGISTER_INSTALLATION_MODAL.TEXT'
        ) | translate
      }}
    </div>
    <div class="note">
      <b>{{ 'DEREGISTER_INSTALLATION_MODAL.NOTE_LABEL' | translate }}: </b>
      <span>{{ 'DEREGISTER_INSTALLATION_MODAL.NOTE_TEXT' | translate }}</span>
    </div>
  </mat-card-content>
  <mat-card-actions class="flex flex-row gap-[8px] justify-end items-center">
    <button
      data-at-cancel-button
      mat-button
      gtm="onCancelDialog"
      gtmCategory="deregisterInstallation"
      color="primary"
      (click)="onCancel()"
    >
      {{ 'GENERAL.BUTTON.CANCEL' | translate }}
    </button>
    <button
      data-at-deregister-button
      mat-raised-button
      gtm="onInstallationDeregister"
      color="primary"
      (click)="onConfirm()"
    >
      {{
        (data.gatewaySerial
          ? 'DEREGISTER_GATEWAY_MODAL.DEREGISTER_GATEWAY_BTN'
          : 'DEREGISTER_INSTALLATION_MODAL.DEREGISTER_INSTALLATION_BTN'
        ) | translate
      }}
    </button>
  </mat-card-actions>
</mat-card>
